module.exports = __webpack_public_path__ + "static/img/workPassEn.43c138cd.png";